import { removeDecimalZero } from '../utils/number';
import Decimal from 'decimal.js';

export interface IPackageModel {
  id: string;
  unitName: string;
  unitCode: string;
  conversionRules?: string;
  pcsCount: number;
}

export type TPackageUnitCode = 'PCS' | 'BX1' | 'BX2' | 'KAR';

export const useProductPackage = () => {
  const displayUnitNameList: TPackageUnitCode[] = ['PCS', 'BX1', 'BX2', 'KAR'];

  const generateConvertRelationStr = (packageList: IPackageModel[] = []) => {
    if (!packageList.length) return '';

    return displayUnitNameList
      .map((unitName) => packageList?.find((item) => item.unitCode.match(new RegExp(unitName)))?.pcsCount ?? '-')
      .join('/');
  };

  const convertToLargePackage = (
    sourceNum: number,
    sourceUnitCode: TPackageUnitCode,
    targetUnitCode: TPackageUnitCode,
    packageList: IPackageModel[] = [],
    precision = 4
  ) => {
    if (!sourceNum) return sourceNum;

    const sourcePackage = packageList.find((item) => item.unitCode === sourceUnitCode);
    const targetPackage = packageList.find((item) => item.unitCode === targetUnitCode);

    if (!sourcePackage || !targetPackage) return sourceNum;

    // 超过precision位数直接舍弃
    const result = new Decimal(sourcePackage.pcsCount)
      .mul(new Decimal(sourceNum))
      .div(new Decimal(targetPackage.pcsCount))
      .toDecimalPlaces(precision)
      .toString();

    return Number(removeDecimalZero(result));
  };

  return {
    generateConvertRelationStr,
    convertToLargePackage
  };
};
